import { render } from "./Secoes.vue?vue&type=template&id=45b557bb"
import script from "./Secoes.vue?vue&type=script&lang=js"
export * from "./Secoes.vue?vue&type=script&lang=js"

import "./Secoes.vue?vue&type=style&index=0&id=45b557bb&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/facilitabots.interagev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__